import { Component, OnInit, Inject } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { ReportsState, getAllLoaded, LoadLinescore, LoadDriver, LoadBrandsData, LoadOther, LoadRatings, getAllEntities, StageMany, getCache } from '../store';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { tap, filter, switchMap, take } from 'rxjs/operators';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'ls-many-selector',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './many-selector.component.html',
    styleUrls: ['./many-selector.component.scss'],
    standalone: true,
    imports: [NgIf, MatProgressSpinnerModule, AsyncPipe]
})
export class ManySelectorComponent implements OnInit {

    data$: Observable<any>;
    loading: boolean = false;

    constructor(
        private store: Store<ReportsState>,
        @Inject(MAT_DIALOG_DATA) private data: { cacheKey: string, type: string },
        private dialogRef: MatDialogRef<ManySelectorComponent>
    ) { }

    ngOnInit() {
        const cacheKey = this.data.cacheKey;
        // this.store.dispatch(new LoadAllData(this.data.cacheKey));
        this.data$ = this.store.pipe(
            select(getCache),
            switchMap(cache => {
                return this.store.pipe(
                    select(getAllLoaded),
                    tap(allLoaded => {
                        if (!this.loading && !allLoaded) {

                            this.loading = true;
                            this.store.dispatch(new LoadLinescore(cacheKey));
                            this.store.dispatch(new LoadDriver(cacheKey));
                            this.store.dispatch(new LoadBrandsData(cacheKey));
                            this.store.dispatch(new LoadOther({ cacheKey: cache.cache_key, crosstab: cache.report_type === 'crosstab' }));
                            this.store.dispatch(new LoadRatings(cacheKey));
                        }
                    }),
                    filter(loaded => loaded),
                    take(1),
                )
            }),
            switchMap(() => this.store.pipe(select(getAllEntities))),
            tap(stuff => {
                console.log(stuff.map(item => item.type));
                const items = stuff.filter(item => {
                    if (this.data.type === 'linescale' && (item.type === 'rating_set' || item.type === 'linescale' || item.type === 'diagnostic'))
                        return true;
                    return item.type === this.data.type;
                }).map(item => {
                    if (item.type === 'rating_set' || item.type === 'linescale' || item.type === 'diagnostic') {
                        return {
                            downloadURL: `data:image/png;base64,${item.image}`,
                            id: item.id || item.rsid,
                            type: 'linescale'
                        };
                    }
                    return item;
                })
                this.store.dispatch(new StageMany(items));
                this.dialogRef.close();
            })
        );

    }

}
